export default "__VITE_ASSET__YpHW9VqIEXDMtd0DnGJDPg__"